import { RenderContext, Session } from '@eventbrite/checkout-fairy-api';
import { EventStatus } from '../../../constants/eventStatus';

const getNextAvailableSession = (
    eventDates: RenderContext['eventDates'],
): Session | null => {
    if (!eventDates) {
        return null;
    }
    const itemWithAvailableSession = eventDates.find((date) => {
        if (date.availability === EventStatus.soldOut) {
            return null;
        }
        return date.sessions.find(
            (session) => session.availability !== EventStatus.soldOut,
        );
    });

    if (itemWithAvailableSession) {
        return itemWithAvailableSession.sessions.find(
            (session) => session.availability !== EventStatus.soldOut,
        ) as Session;
    }

    return null;
};

export default getNextAvailableSession;
